import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'
import { ILanguage } from 'static/languages'

const URL = `/auth/register`

const register = (data: {
  email: string
  password: string
  preferredCurrency: number
  clickId?: string | null
  visitorId: string
  offer?: string | null
  partnerId?: string | null
  language?: ILanguage['locale']
  sessionId?: string | null
}): AxiosPromise =>
  apiFetch(URL, {
    data,
    method: `POST`,
  })

export default register
